import React from 'react';
import { Spinner } from 'react-bootstrap';

function LoadSpinner() {
  return (
      <>
    <Spinner animation="border" variant="danger" />
    </>
  );
};

export default LoadSpinner;